
















import { Component, Vue } from "vue-property-decorator";
import GrpTargetEditor from "@/components/GrpTargetEditor.vue";
import GrpTargetSelect from "@/components/GrpTargetSelect.vue";
import Step from "@/components/GrpTargets/Step.vue";

@Component({
  components: {
    GrpTargetSelect,
    Step,
  },
})
export default class Other extends Vue {}
